import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { HiveObjectDataset } from 'app/model/dataset/hive.dataset';
import { Metamodel } from 'app/model/base/model';
import { HiveLinkedService } from 'app/model/linkedservice/hive.linkedservice';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';
import { GlobalVariables } from 'app/services/globals';
import { batchSizeV2Metadata, queryTimeoutV2Metadata } from '../consts/metadata-consts';

export const hiveObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(HiveObjectDataset).name,
    displayName: stringResources.Hive_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(HiveLinkedService).name],
    isSource: true,
    isSink: false,
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
         stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-hive',
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Hive'
    },
    isFirstClass: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.SByte),
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    copySourceControls: [
        GlobalVariables.enableHiveV2BatchSize
            ? {
                  ...batchSizeV2Metadata,
                  child: {
                      ...batchSizeV2Metadata.child,
                      description: format(
                          stringResources.BatchSize_Description_Template,
                          stringResources.Hive_DisplayText
                      )
                  },
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined,
        GlobalVariables.enableHiveV2QueryTimeout
            ? {
                  ...queryTimeoutV2Metadata,
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined
    ].filter(Boolean)
};
